export class AreaParticipacao {
    areaparticipacaoid: number;
    nome: string
    descricao: string;
    ativo: boolean;
}